import React from "react";
import { Typography, Flex } from "antd";
import { Link } from "react-router-dom";

const { Title } = Typography;

export default function Footer() {
  const footerSections = [
    {
      title: "Platform",
      links: [
        { label: "Explore Events", to: "/discover-events" },
        { label: "Host an Event", to: "/host-event" },
        { label: "Templates", to: "/templates" },
      ],
    },
    {
      title: "Support",
      links: [
        { label: "About Us", to: "/about-us" },
        { label: "FAQs", to: "/faqs" },
        { label: "Contact Us", to: "/contact-us" },
      ],
    },
    {
      title: "Legal",
      links: [
        { label: "Privacy Policy", to: "/privacy-policy" },
        { label: "Cancellation Policy", to: "/cancellation-policy" },
        { label: "Refund Policy", to: "/refund-policy" },
        { label: "Terms & Conditions", to: "/terms-and-conditions" },
        { label: "Help", to: "/help" },
      ],
    },
  ];

  return (
    <section className="footerSection footerV2Section">
      <div className="container">
        <footer className="siteFooter footerV2">
          <div className="footerV2Top">
            <div className="footerV2BrandCol">
              <Title level={4}>Pingvite</Title>
              <p>
                Discover inspiring events, connect with people nearby, and host your own experiences in minutes.
              </p>
              <div className="footerV2Socials">
                <a href="https://facebook.com" target="_blank" rel="noreferrer">
                  Facebook
                </a>
                <a href="https://instagram.com" target="_blank" rel="noreferrer">
                  Instagram
                </a>
                <a href="https://linkedin.com" target="_blank" rel="noreferrer">
                  LinkedIn
                </a>
              </div>
            </div>
            <div className="footerV2LinksGrid">
              {footerSections.map((section) => (
                <div className="footerGridCol" key={section.title}>
                  <Flex vertical gap={8}>
                    <Title level={5}>{section.title}</Title>
                    <Flex vertical gap={6}>
                      {section.links.map((item) => (
                        <Link to={item.to || "/coming-soon"} className="footer-link" key={item.label}>
                          {item.label}
                        </Link>
                      ))}
                    </Flex>
                  </Flex>
                </div>
              ))}
            </div>
          </div>
          <div className="copyright footerV2Bottom">
            {`© Copyright Pingvite 2026. All Rights Reserved.`}
          </div>
        </footer>
      </div>
    </section>
  );
}
